import { render, staticRenderFns } from "./ModalDesfazerIntegracao.vue?vue&type=template&id=67f8b01c"
import script from "./ModalDesfazerIntegracao.vue?vue&type=script&lang=ts"
export * from "./ModalDesfazerIntegracao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports